import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CompanyDebtorMinuteRequestResolutionDTO } from '../../minutes/interface/minute-detail';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CompanyDebtorMinuteResolutionDTO } from '../../minutes/interface/minute-request.interface';
import { MinuteRequestService } from '../../minutes/service/minute-request.service';
import { finalize, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { faCircleMinus, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-minute-debtor-company-resolutions',
  templateUrl: './minute-debtor-company-resolutions.component.html',
  styleUrls: ['./minute-debtor-company-resolutions.component.scss']
})
export class MinuteDebtorCompanyResolutionsComponent implements OnInit, OnChanges {

  //Input para recibir todas las resoluciones de deudores de minuta
  @Input() minuteDebtorResolutions: Array<CompanyDebtorMinuteRequestResolutionDTO>;
  @Input() minuteRequestId: number;
  @Input() canChangeResolution: boolean;
  @ViewChild(MatSort) sort: MatSort;

  public loadingDebtors: Array<number> = [];

  public dataSource: MatTableDataSource<CompanyDebtorMinuteRequestResolutionDTO>;
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;

  // Columnas de la tabla a mostrar
  public displayedColumns: string[] = [
    'fullRut',
    'name',
    'buyInvoices',
    'buyInvoiceTotalAmount',
    'receivedCreditNotes',
    'receivedCreditNotesTotalAmount',
    'resolutionStateName'
  ];

  public icons = {
    faCircleMinus, faCircleCheck, faCircleXmark
  };

  constructor(private minuteRequestService: MinuteRequestService,
    private toastrService: ToastrService) {
    this.paginator = Object.create(null);
    this.minuteDebtorResolutions = new Array<CompanyDebtorMinuteRequestResolutionDTO>();
    this.canChangeResolution = false;
  }

  ngOnInit(): void {
    this.setTableDataSource(this.minuteDebtorResolutions);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setTableDataSource(this.minuteDebtorResolutions);
  }

  isLoadingDebtor(companyId: number): boolean {
    return this.loadingDebtors.includes(companyId);
  }

  private setTableDataSource(dataSource: Array<CompanyDebtorMinuteRequestResolutionDTO>){
    this.dataSource = new MatTableDataSource<CompanyDebtorMinuteRequestResolutionDTO>(dataSource);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public toggleDebtorResolutionChange(event: MatButtonToggleChange, companyId: number, currentState: number) {
    this.loadingDebtors.push(companyId);
    const selectedOption = event.value;
    let updateDebtorResolution$: Observable<CompanyDebtorMinuteResolutionDTO> = new Observable<CompanyDebtorMinuteResolutionDTO>;
    switch(selectedOption){
      case 0:
        updateDebtorResolution$ = this.minuteRequestService.pendingDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
      case 2: 
        updateDebtorResolution$ = this.minuteRequestService.approveDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
      case 3:
        updateDebtorResolution$ = this.minuteRequestService.rejectDebtorCompanyMinute(companyId, this.minuteRequestId);
        break;
    }

    updateDebtorResolution$
    .pipe(
      finalize(() => {
        this.loadingDebtors = this.loadingDebtors.filter(d => d !== companyId);
      })
    )
    .subscribe({
      error: (err) =>{
        //Revertir estado al estado anterior
        event.source.buttonToggleGroup.writeValue(currentState)      
        this.toastrService.error(err.error?.message || 'Ha ocurrido un error');
      }
    })

  }
}
